import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../../store/hooks';
import { AppDispatch } from '../../../../store/models/app-dispatch.model';

export const useToggleFiltersVisibility = (
  toggleFiltersVisibilityFn: ActionCreatorWithoutPayload<string>
): (() => void) => {
  const dispatch: AppDispatch = useAppDispatch();
  return () => dispatch(toggleFiltersVisibilityFn());
};
